// src/pages/AuthCallback.jsx
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function handleAuthCallback() {
      try {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");

        if (!token) {
          console.error("No token found in callback URL");
          navigate("/login", { replace: true });
          return;
        }

        // ✅ Save token locally
        localStorage.setItem("token", token);

        // ✅ Try to get user profile
        let profile;
        try {
          const res = await api.get("/profile");
          profile = res.data;
        } catch (err) {
          console.warn("No profile found, redirecting to onboarding");
          navigate("/onboarding", { replace: true });
          return;
        }

        // ✅ Check if profile is complete
        const isComplete =
          profile &&
          profile.fullName?.trim() &&
          profile.phone?.trim() &&
          profile.title?.trim();

        // ✅ Redirect accordingly
        if (!isComplete) {
          navigate("/onboarding", { replace: true }); // go to QuickProfileSetup
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch (err) {
        console.error("Auth callback failed:", err);
        localStorage.removeItem("token");
        navigate("/login", { replace: true });
      }
    }

    handleAuthCallback();
  }, [navigate, location.search]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-lg font-medium">Finishing sign-in, please wait...</p>
    </div>
  );
}
